module.exports = __webpack_public_path__ + "img/9-7.cae5a412.png";